import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// TODO: Replace the following with your app's Firebase project configuration
// See: https://support.google.com/firebase/answer/7015592
const firebaseConfig = {
    apiKey: "AIzaSyCbML41-0ZT3_QdOPzlGVXZefC1jGZ_alY",
    authDomain: "lemniscate-e1c89.firebaseapp.com",
    projectId: "lemniscate-e1c89",
    storageBucket: "lemniscate-e1c89.firebasestorage.app",
    messagingSenderId: "125107296445",
    appId: "1:125107296445:web:a69ddb42b4806d42cc7fd4"
  
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
